import { all, takeEvery, put, fork, call } from "redux-saga/effects";
import actions from "./actions";
import AxiosInterceptor from "../../Services/axiosIntercepter";
import examaInterceptor from "../../Services/examinterceptor";

// Helper functions for API calls
const createData = async (payload) => {
  const { url, body } = payload;
  const result = await AxiosInterceptor.post(url, body);
  return result;
};

const updateData = async (payload) => {
  const { url, body } = payload;
  const result = await AxiosInterceptor.put(url, body);
  return result;
};

const getData = async (payload) => {
  const { url } = payload;
  const result = await AxiosInterceptor.get(url);
  return result;
};

const enrollExam = async (payload) => {
  const { url, body } = payload;
  const result = await examaInterceptor.post(url, body);
  return result;
};

// Saga for creating student personal details
export function* STUDENT_PERSONAL_DETAILS_SAGA() {
  yield takeEvery(
    actions.STUDENT_PERSONAL_DETAILS_CREATE_REQUEST,
    function* ({ payload }) {
      try {
        const res = yield call(createData, payload);
        localStorage.setItem("Student_Id", res?.data?.data?.createStudent?._id);
        if (res.data.status_code === 1) {
          yield put({
            type: actions.STUDENT_PERSONAL_DETAILS_CREATE_SUCCESS,
            message: res?.data?.message,
            status_code: res?.data?.status_code,
          });
        } else {
          yield put({
            type: actions.STUDENT_PERSONAL_DETAILS_CREATE_ERROR,
            message: res?.data?.message || "Failed to create the student.",
            status_code: res?.data?.status_code,
          });
        }
      } catch (error) {
        console.log(error);
        yield put({
          type: actions.STUDENT_PERSONAL_DETAILS_CREATE_ERROR,
          message: error?.response?.data?.message,
          status_code: error?.data?.status_code,
        });
      }
    }
  );
}

// Saga for updating student details
export function* updateStudentDetails() {
  yield takeEvery(
    actions.STUDENT_DETAILS_UPDATE_REQUEST,
    function* ({ payload }) {
      try {
        const res = yield call(updateData, payload);
        if (res.data.status_code === 1) {
          yield put({
            type: actions.STUDENT_DETAILS_UPDATE_SUCCESS,
            message: res.data?.message,
            status_code: res.data?.status_code,
          });
        } else {
          yield put({
            type: actions.STUDENT_DETAILS_UPDATE_ERROR,
            message: res?.data?.message,
            status_code: res.data.status_code,
          });
        }
      } catch (error) {
        yield put({
          type: actions.STUDENT_DETAILS_UPDATE_ERROR,
          message: error?.response?.data?.message,
          status_code: error?.data?.status_code,
        });
      }
    }
  );
}

// Saga for getting student personal details
export function* getStudentPersonalDetails() {
  yield takeEvery(
    actions.STUDENT_PERSONAL_DETAILS_GET_REQUEST,
    function* ({ payload }) {
      try {
        const res = yield call(getData, payload); // Fetch student details based on the URL
        if (res.data.status_code === 1) {
          yield put({
            type: actions.STUDENT_PERSONAL_DETAILS_GET_SUCCESS,
            data: res.data?.data, // Pass the fetched student data
            message: res.data?.message,
            status_code: res.data?.status_code,
          });
        } else {
          yield put({
            type: actions.STUDENT_PERSONAL_DETAILS_GET_ERROR,
            message:
              res?.data?.message || "Failed to retrieve student details.",
            status_code: res?.data?.status_code,
          });
        }
      } catch (error) {
        yield put({
          type: actions.STUDENT_PERSONAL_DETAILS_GET_ERROR,
          message:
            error?.response?.data?.message || "Failed to fetch student details",
          status_code: error?.data?.status_code,
        });
      }
    }
  );
}

export function* createEnrolledExamSaga() {
  yield takeEvery(
    actions.ENROLLED_EXAMS_CREATE_REQUEST,
    function* ({ payload }) {
      try {
        const res = yield call(enrollExam, payload);
        if (res.data.status_code === 1) {
          yield put({
            type: actions.ENROLLED_EXAMS_CREATE_SUCCESS,
            message: res.data?.message,
            status_code: res.data?.status_code,
          });
        } else {
          yield put({
            type: actions.ENROLLED_EXAMS_CREATE_ERROR,
            message: res?.data?.message || "Failed to create enrolled exam.",
            status_code: res.data.status_code,
          });
        }
      } catch (error) {
        yield put({
          type: actions.ENROLLED_EXAMS_CREATE_ERROR,
          message: error?.response?.data?.message,
          status_code: error?.data?.status_code,
        });
      }
    }
  );
}

// Root Saga for all sagas related to student
export default function* rootSaga() {
  yield all([
    fork(STUDENT_PERSONAL_DETAILS_SAGA),
    fork(updateStudentDetails),
    fork(getStudentPersonalDetails), // Add the GET saga here,
    fork(createEnrolledExamSaga),
  ]);
}
